import { useTranslation } from 'react-i18next';

import { Tip } from '@/components/shared/tip';
import { Button } from '@/components/ui/button';
import {
  CAMPAIGN_MERGE_FIELD_KEYS,
  GIVING_MERGE_FIELD_KEYS,
  mergeFieldToken,
  type CampaignMergeFieldKey,
  type GivingMergeFieldKey,
} from '@/lib/messaging-merge-fields';

interface MergeFieldInserterProps {
  onInsert: (token: string) => void;
  disabled?: boolean;
  /** Show giving-specific tokens such as amount and fund name. */
  includeGivingFields?: boolean;
  /** Show the tip under the chip row. Defaults to true. */
  showTip?: boolean;
}

export const MergeFieldInserter = ({
  onInsert,
  disabled = false,
  includeGivingFields = false,
  showTip = true,
}: MergeFieldInserterProps) => {
  const { t } = useTranslation('messaging');

  return (
    <div className="mt-1 space-y-1">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-caption text-fg-secondary">{t('mergeFields.label')}</p>
        {CAMPAIGN_MERGE_FIELD_KEYS.map((key: CampaignMergeFieldKey) => (
          <Button
            key={key}
            type="button"
            size="sm"
            variant="outline"
            disabled={disabled}
            onClick={() => onInsert(mergeFieldToken(key))}
          >
            {t(`mergeFields.${key}`)}
          </Button>
        ))}
        {includeGivingFields
          ? GIVING_MERGE_FIELD_KEYS.map((key: GivingMergeFieldKey) => (
              <Button
                key={key}
                type="button"
                size="sm"
                variant="outline"
                disabled={disabled}
                onClick={() => onInsert(mergeFieldToken(key))}
              >
                {t(`mergeFields.${key}`)}
              </Button>
            ))
          : null}
      </div>
      {showTip ? <Tip tipId="messaging.mergeFields" /> : null}
    </div>
  );
};
